module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Aida Huseynova\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Aida Huseynova, a musicologist from Azerbaijan, is Adjunct Lecturer in Music at the Jacobs School of Music at Indiana University. She is the author of the educational DVD Music and Culture of Azerbaijan and author (with Munara Mailybekova) of the DVD Music and Culture of Kyrgyzstan.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/V0yD9G/tc-custom/9780253019493.jpg?1737196543043",
      "alt": "This image is the cover for the book Music of Azerbaijan, Ethnomusicology Multimedia"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Music of Azerbaijan, Ethnomusicology Multimedia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This book traces the development of Azerbaijani art music from its origins in the Eastern, modal, improvisational tradition known as mugham through its fusion with Western classical, jazz, and world art music. Aida Huseynova places the fascinating and little-known history of music in Azerbaijan against the vivid backdrop of cultural life under Soviet influence, which paradoxically both encouraged and repressed the evolution of national musics and post-Soviet independence. Inspired by their neighbors to the East and West, Azerbaijani musicians enjoyed a period of remarkable creativity, composing and performing the first opera and the first ballet in the Muslim East, establishing the region's first Opera and Ballet Theater and Conservatory of Music, and discovering ways to merge the modal lyricism of mugham with the rhythmic dynamics of jazz. Drawing on previously unstudied archives, letters, and documents as well as her experience as an Azerbaijani musician and educator, Huseynova shows how Azerbaijani musical development was not a product of Soviet cultural policies but rather grew from and reflected deep and complex cultural processes.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0